import React, { createContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import useCommonListFunctions, {
	CommonListFunctionsType,
	useExtendCommonListFunctions,
} from "../../../hooks/useCommonList/useCommonListFunctions";
import {
	AdminOrderManagementFilterItem,
	BookingFilterButton,
	BookingFilterTitle,
	BookingFilterWrap,
} from "../../MyBooking/styled/DesStyled";
import PartnerKeywordSearch from "./PartnerKeywordSearch";
import { UserFilterWrap } from "../../User/styled/UserStyled";
import { AdminOrderManagementFilterInput } from "../../MyBooking/component/BookingFilter";
import { userStatusList, useStatusFilter } from "../hook/useFilterStatus";
import { SelectOptionType } from "react-select";
import { SmSelectSearchBox } from "../../../controls/components/selectSearchBox/SelectSearchBox";
import DialogAddPartnerAdmin from "./DialogAddPartnerAdmin";
import { AdminFilterEmailPartner } from "../hook/FilterEmailPartner";
import useFilterCountryCity from "../hook/useFilterCountryCity";

export default function PartnerFilter(props: { reload: () => void }) {
	const {
		filterActive,
		filterKeyword,
		doFilterKeyword,
		doChangeFilterField,
		filterStore,
		doFilterStore,
		filterUserIdString,
		doFilterUserIdString,
		filterNoLocation,
	} = useCommonListFunctions();
	const [isDialogLoginOpen, setIsDialogLoginOpen] = useState(false);
	const { statusSelected, handleFilter } = useStatusFilter();
	const {
		countryOptions,
		cityOptions,
		selectedCountry,
		selectedDestinationId,
		handleCountryChange,
		handleCityChange,
	} = useFilterCountryCity();
	const [noLocation, setNoLocation] = useState(filterNoLocation === "true");

	const doChangeStatusString = (value: any) => {
		doChangeFilterField?.({
			filterStates: value,
		});
	};

	const onCountryChange = (val: any) => {
		handleCountryChange(val);
		doChangeFilterField?.({
			filterCountry: val.value || null,
			filterDestinationId: null,
		});
	};

	const onCityChange = (val: any) => {
		handleCityChange(val);
		doChangeFilterField?.({
			filterDestinationId: val.value || null,
		});
	};

	const onNoLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const checked = e.target.checked;
		setNoLocation(checked);
		doChangeFilterField?.({
			filterNoLocation: checked ? "true" : null,
			filterCountry: null,
			filterDestinationId: null,
		});
		if (checked) {
			handleCountryChange({ value: "" });
		}
	};

	const openAdd = () => {
		setIsDialogLoginOpen(true);
	};
	return (
		<UserFilterWrap>
			<BookingFilterWrap>
				<AdminOrderManagementFilterItem>
					<BookingFilterTitle>Filter by keyword</BookingFilterTitle>
					<PartnerKeywordSearch
						filterKeyword={filterKeyword}
						doFilterKeyword={doFilterKeyword}
					/>
				</AdminOrderManagementFilterItem>

				<AdminOrderManagementFilterItem>
					<BookingFilterTitle>Filter by status</BookingFilterTitle>
					<ProductFilterStatusSelect
						isSearchable={false}
						options={userStatusList}
						value={statusSelected}
						setvalue={(val) => handleFilter(val.value)}
					/>
				</AdminOrderManagementFilterItem>

				{/* Ô lọc "Ban" đã GỘP vào "Filter by status" (Quân chốt 25/08, phương án A đầy đủ).
				    Giữ hai ô là hai đường cùng lọc ra một tập — chọn Status=Banned và Ban=true cho
				    cùng kết quả, còn chọn lệch nhau thì ra rỗng mà không ai hiểu vì sao.
				    Hạ tầng `filterBanned` GIỮ NGUYÊN vì màn User đang dùng chung. */}

				<AdminOrderManagementFilterItem>
					<BookingFilterTitle>Filter by Email</BookingFilterTitle>
					<AdminFilterEmailPartner
						filterStaffId={filterStore || ""}
						doChangeStaffId={doFilterStore}
					/>
				</AdminOrderManagementFilterItem>

				<AdminOrderManagementFilterItem>
					<BookingFilterTitle>Filter by user name</BookingFilterTitle>
					<AdminFilterEmailPartner
						name={true}
						filterStaffId={filterUserIdString || ""}
						doChangeStaffId={doFilterUserIdString}
					/>
				</AdminOrderManagementFilterItem>
			</BookingFilterWrap>

			<BookingFilterWrap>
				<AdminOrderManagementFilterItem style={{ opacity: noLocation ? 0.5 : 1 }}>
					<BookingFilterTitle>Filter by Country</BookingFilterTitle>
					<SmSelectSearchBox
						isSearchable={true}
						isDisabled={noLocation}
						options={countryOptions}
						value={
							noLocation
								? countryOptions[0]
								: countryOptions.find((o) => o.value === selectedCountry) || countryOptions[0]
						}
						onChange={onCountryChange}
						menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
					/>
				</AdminOrderManagementFilterItem>

				<AdminOrderManagementFilterItem style={{ opacity: noLocation ? 0.5 : 1 }}>
					<BookingFilterTitle>Filter by City</BookingFilterTitle>
					<SmSelectSearchBox
						isSearchable={true}
						isDisabled={noLocation}
						options={cityOptions}
						value={
							noLocation
								? cityOptions[0]
								: cityOptions.find((o) => o.value === selectedDestinationId) || cityOptions[0]
						}
						onChange={onCityChange}
						menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
					/>
				</AdminOrderManagementFilterItem>

				<AdminOrderManagementFilterItem>
					<label
						style={{
							display: "flex",
							alignItems: "center",
							gap: "8px",
							cursor: "pointer",
							marginTop: "24px",
							padding: "6px 16px",
							borderRadius: "100px",
							border: noLocation ? "1px solid #00a1ca" : "1px solid #d9e0e4",
							background: noLocation ? "#e6f7fc" : "#fff",
							whiteSpace: "nowrap",
						}}>
						<input
							type="checkbox"
							checked={noLocation}
							onChange={onNoLocationChange}
							style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#00a1ca" }}
						/>
						{/* 17/10: bộ lọc này là thiếu TOẠ ĐỘ bản đồ (Station là tên gốc, không còn "Location"). */}
						<span style={{ fontSize: "14px" }}>No map coordinates</span>
					</label>
				</AdminOrderManagementFilterItem>

				<div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
					<BookingFilterButton onClick={openAdd}>Add</BookingFilterButton>
				</div>
			</BookingFilterWrap>

			<DialogAddPartnerAdmin
				openDialog={isDialogLoginOpen}
				setOpenDialog={setIsDialogLoginOpen}
				reload={props.reload}
			/>
		</UserFilterWrap>
	);
}

export const ProductFilterStatusSelect = (props: {
	options: SelectOptionType[];
	value: SelectOptionType;
	setvalue: (val: SelectOptionType) => void;
	isSearchable?: boolean;
}) => {
	return (
		<SmSelectSearchBox
			isSearchable={props.isSearchable}
			options={props.options}
			value={props.value}
			onChange={props.setvalue}></SmSelectSearchBox>
	);
};
